// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import MassActionResults from '../search-data/mass-action-results';
import MassActionDetail from '../search-data/mass-action-detail';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Mass Action Results',
                                component: MassActionResults,
                            },
                        ],
                    },
                ],
            },
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Mass Action Detail',
                                component: MassActionDetail,
                            },
                        ],
                    },
                ],
                weight: 125,
            },
        ],
    },
};

function DashboardMassActionResults() {
    return (
        <FlexDashboard
            dashboardConfig={getDashboardConfig(dashboardConfig)}
            dashboardName="massActionResults"
            version="2"
        />
    );
}

export default DashboardMassActionResults;
